import SilentWitnessFileItem from './SilentWitnessFileItem';

const SilentWitnessFileGroup = ({ group }) => {
  return (
    <>
      {group.items.map((item) => (
        <SilentWitnessFileItem
          key={`${group.key}-${item.index}`}
          item={item}
          groupKey={group.key}
        />
      ))}
    </>
  );
};

export default SilentWitnessFileGroup;
